/** LookupEnums (LE) must align with their associated Lookups. The associated Lookups must be marked as immutable.
 * Name the enum for the LookupGroup's Code. Name the keys to align with the Lookup's Code. The values should align with the Lookup's Murn.
 */
export namespace LE {
  export enum AirQualityRegulation {
    IndustrialAdhesiveOperations = "murn:aqms2:lookup/AirQualityRegulation/101",
    GasolineDispensingFacilities = "murn:aqms2:lookup/AirQualityRegulation/102",
    MiscellaneousMetalOrPlasticPartsCoatingOperations = "murn:aqms2:lookup/AirQualityRegulation/103",
    IndustrialCleaningSolventOperations = "murn:aqms2:lookup/AirQualityRegulation/104",
    MetalSolventDegreaserOperations = "murn:aqms2:lookup/AirQualityRegulation/105",
    GraphicArtsOperations = "murn:aqms2:lookup/AirQualityRegulation/106",
    CutbackAsphaltManufacturingAndUse = "murn:aqms2:lookup/AirQualityRegulation/107",
  }

  export enum ApplicationMethod {
    Other = "murn:aqms2:lookup/ApplicationMethod/Other",
  }

  export enum ApplicationType {
    Transfer = "murn:aqms2:lookup/ApplicationType/Transfer",
    NameChange = "murn:aqms2:lookup/ApplicationType/NameChange",
  }

  export enum AqrSection {
    OpenVacantLands = "murn:aqms2:lookup/AqrSection/90",
    UnpavedRoads = "murn:aqms2:lookup/AqrSection/91",
    UnpavedParkingLotsPre = "murn:aqms2:lookup/AqrSection/pre92",
    UnpavedParkingLotsPost = "murn:aqms2:lookup/AqrSection/92",
    PavedRoads = "murn:aqms2:lookup/AqrSection/93",
    FugitiveDust = "murn:aqms2:lookup/AqrSection/41",
  }

  export enum AsbestosNonFriableCategory {
    Cat1 = "murn:aqms2:lookup/AsbestosNonFriableCategory/Cat1",
    Cat2 = "murn:aqms2:lookup/AsbestosNonFriableCategory/Cat2",
  }

  export enum AsbestosNotificationType {
    Cancellation = "murn:aqms2:lookup/AsbestosNotificationType/Cancellation",
  }

  export enum AsbestosNotificationFormType {
    Aaf = "murn:aqms2:lookup/AsbestosNotificationFormType/Aaf",
  }

  export enum AuxiliaryEquipment {
    Conveyors = "murn:aqms2:lookup/AuxiliaryEquipment/Conveyors",
    HoppersBins = "murn:aqms2:lookup/AuxiliaryEquipment/HoppersBins",
    PugmillsMixers = "murn:aqms2:lookup/AuxiliaryEquipment/PugmillsMixers",
    Silos = "murn:aqms2:lookup/AuxiliaryEquipment/Silos",
    Stackers = "murn:aqms2:lookup/AuxiliaryEquipment/Stackers",
    Stockpiles = "murn:aqms2:lookup/AuxiliaryEquipment/Stockpiles",
    Other = "murn:aqms2:lookup/AuxiliaryEquipment/Other",
  }

  export enum BagCleaningMethod {
    Air = "murn:aqms2:lookup/BagCleaningMethod/Air",
    Mechanical = "murn:aqms2:lookup/BagCleaningMethod/Mechanical",
    Shakings = "murn:aqms2:lookup/BagCleaningMethod/Shakings",
    Other = "murn:aqms2:lookup/BagCleaningMethod/Other",
  }

  export enum CauseType {
    MStartup = "murn:aqms2:lookup/CauseType/MStartup",
    MShutdown = "murn:aqms2:lookup/CauseType/MShutdown",
    ScheduledMaintenance = "murn:aqms2:lookup/CauseType/ScheduledMaintenance",
    UpsetBreakdown = "murn:aqms2:lookup/CauseType/UpsetBreakdown",
    Other = "murn:aqms2:lookup/CauseType/Other",
  }

  export enum CoatedMaterial {
    Other = "murn:aqms2:lookup/CoatedMaterial/Other",
  }

  export enum CoatedProduct {
    Other = "murn:aqms2:lookup/CoatedProduct/Other",
  }

  export enum ComplaintCloseReason {
    NoInvestigation = "murn:aqms2:lookup/ComplaintCloseReason/NoInvestigation",
    NotApplicable = "murn:aqms2:lookup/ComplaintCloseReason/NotApplicable",
    Investigated = "murn:aqms2:lookup/ComplaintCloseReason/Investigated",
  }

  export enum ComplaintStatus {
    Open = "murn:aqms2:lookup/ComplaintStatus/Open",
    Pending = "murn:aqms2:lookup/ComplaintStatus/Pending",
    Closed = "murn:aqms2:lookup/ComplaintStatus/Closed",
  }

  export enum ComplaintType {
    Fireplace = "murn:aqms2:lookup/ComplaintType/Fireplace",
    FuelLeak = "murn:aqms2:lookup/ComplaintType/FuelLeak",
    FugitiveDust = "murn:aqms2:lookup/ComplaintType/FugitiveDust",
    IdlingVehicles = "murn:aqms2:lookup/ComplaintType/IdlingVehicles",
    Odor = "murn:aqms2:lookup/ComplaintType/Odor",
    Other = "murn:aqms2:lookup/ComplaintType/Other",
    OpenBurning = "murn:aqms2:lookup/ComplaintType/OpenBurning",
    OversprayFallout = "murn:aqms2:lookup/ComplaintType/OversprayFallout",
    RenovationDemo = "murn:aqms2:lookup/ComplaintType/RenovationDemolition",
    Stockpiles = "murn:aqms2:lookup/ComplaintType/Stockpiles",
    StreetSweeper = "murn:aqms2:lookup/ComplaintType/StreetSweeper",
    Trackout = "murn:aqms2:lookup/ComplaintType/Trackout",
    UnpavedParking = "murn:aqms2:lookup/ComplaintType/UnpavedParking",
    UnpavedRoad = "murn:aqms2:lookup/ComplaintType/UnpavedRoad",
    UnpavedStorage = "murn:aqms2:lookup/ComplaintType/UnpavedStorage",
    VacantLand = "murn:aqms2:lookup/ComplaintType/VacantLand",
    VisibleEmissions = "murn:aqms2:lookup/ComplaintType/VisibleEmissions",
  }

  export enum ControlDeviceType {
    ControlDevice = "murn:aqms2:lookup/ControlDeviceType/ControlDevice",
    Cyclone = "murn:aqms2:lookup/ControlDeviceType/Cyclone",
    Flare = "murn:aqms2:lookup/ControlDeviceType/Flare",
    Fabric = "murn:aqms2:lookup/ControlDeviceType/Fabric",
    Scrubber = "murn:aqms2:lookup/ControlDeviceType/Scrubber",
    None = "murn:aqms2:lookup/ControlDeviceType/None",
  }

  export enum ConstructionActivityType {
    Construction = "murn:aqms2:lookup/ConstructionActivityType/Construction",
    TemporaryCommercial = "murn:aqms2:lookup/ConstructionActivityType/TemporaryCommercial",
  }

  export enum ConstructionProjectAttribute {
    Blasting = "murn:aqms2:lookup/ConstructionProjectAttribute/Blasting",
    StructureDemolition = "murn:aqms2:lookup/ConstructionProjectAttribute/StructureDemolition",
  }
  export enum Country {
    CAN = "murn:aqms2:lookup/Country/CAN",
    USA = "murn:aqms2:lookup/Country/USA",
  }
  export enum CycloneCollectorType {
    Other = "murn:aqms2:lookup/CycloneCollectorType/Other",
  }

  export enum DocumentCategory {
    AsbestosProject = "murn:aqms2:lookup/DocumentCategory/AsbestosProject",
    Complaint = "murn:aqms2:lookup/DocumentCategory/Complaint",
    ConstructionProject = "murn:aqms2:lookup/DocumentCategory/CP",
    DustClass = "murn:aqms2:lookup/DocumentCategory/DustClass",
    StationarySource = "murn:aqms2:lookup/DocumentCategory/SS",
    AsbestosFacility = "murn:aqms2:lookup/DocumentCategory/AsbestosFacility",
    ElectronicForm = "murn:aqms2:lookup/DocumentCategory/ElectronicForm",
    EnforcementAction = "murn:aqms2:lookup/DocumentCategory/EnforcementAction",
    Inspection = "murn:aqms2:lookup/DocumentCategory/Inspection",
    Investigation = "murn:aqms2:lookup/DocumentCategory/Investigation",
  }

  export enum DocumentType {
    BusinessLicense = "murn:aqms2:lookup/DocumentType/BusinessLicense",
    SafetyDataSheet = "murn:aqms2:lookup/DocumentType/SafetyDataSheet",
    FlowDiagram = "murn:aqms2:lookup/DocumentType/FlowDiagram",
    ManufacturersSpecificationSheet = "murn:aqms2:lookup/DocumentType/ManufacturersSpecificationSheet",
    DriftEliminator = "murn:aqms2:lookup/DocumentType/DriftEliminator",
    SupportingDocument = "murn:aqms2:lookup/DocumentType/SupportingDocument",
    EmissionsPrintout = "murn:aqms2:lookup/DocumentType/EmissionsPrintout",
    SourceTest = "murn:aqms2:lookup/DocumentType/SourceTest",
    Map = "murn:aqms2:lookup/DocumentType/Map",
    Permit = "murn:aqms2:lookup/DocumentType/Permit",
    BlastingMapKMZ = "murn:aqms2:lookup/DocumentType/BlastingMapKMZ",
    BlastingMapPDF = "murn:aqms2:lookup/DocumentType/BlastingMapPDF",
    ProjectMapKMZ = "murn:aqms2:lookup/DocumentType/ProjectMapKMZ",
    ProjectMapPDF = "murn:aqms2:lookup/DocumentType/ProjectMapPDF",
    AsbestosSurvey = "murn:aqms2:lookup/DocumentType/AsbestosSurvey",
    Other = "murn:aqms2:lookup/DocumentType/Other",
  }

  export enum DustMitigationPlanWaterApplication {
    Other = "murn:aqms2:lookup/DustMitigationPlanWaterApplication/Other",
  }

  export enum DustMitigationPlanWaterSource {
    Other = "murn:aqms2:lookup/DustMitigationPlanWaterSource/Other",
  }

  export enum ElectronicFormGroup {
    Asbestos = "murn:aqms2:lookup/ElectronicFormGroup/Asbestos",
    Compliance = "murn:aqms2:lookup/ElectronicFormGroup/Compliance",
    DustClass = "murn:aqms2:lookup/ElectronicFormGroup/DustClass",
    DustControlPermitting = "murn:aqms2:lookup/ElectronicFormGroup/DustControlPermitting",
    DustMonitorClass = "murn:aqms2:lookup/ElectronicFormGroup/DustMonitorClass",
    Enforcement = "murn:aqms2:lookup/ElectronicFormGroup/Enforcement",
    OpenBurning = "murn:aqms2:lookup/ElectronicFormGroup/OpenBurning",
    StationarySourcePermitting = "murn:aqms2:lookup/ElectronicFormGroup/StationarySourcePermitting",
    SourceTesting = "murn:aqms2:lookup/ElectronicFormGroup/SourceTesting",
  }

  export enum ElectronicFormRequestStatus {
    Pending = "murn:aqms2:lookup/ElectronicFormRequestStatus/Pending",
    Approved = "murn:aqms2:lookup/ElectronicFormRequestStatus/Approved",
    Denied = "murn:aqms2:lookup/ElectronicFormRequestStatus/Denied",
  }

  export enum ElectronicFormRequestType {
    Repudiation = "murn:aqms2:lookup/ElectronicFormRequestType/Repudiation",
  }

  export enum ElectronicFormRevisionType {
    Administrative = "murn:aqms2:lookup/ElectronicFormRevisionType/Administrative",
    Minor = "murn:aqms2:lookup/ElectronicFormRevisionType/Minor",
    Significant = "murn:aqms2:lookup/ElectronicFormRevisionType/Significant",
  }

  export enum ElectronicFormStatus {
    Draft = "murn:aqms2:lookup/ElectronicFormStatus/Draft",
    SubmissionPending = "murn:aqms2:lookup/ElectronicFormStatus/SubmissionPending",
    Submitted = "murn:aqms2:lookup/ElectronicFormStatus/Submitted",
    Processing = "murn:aqms2:lookup/ElectronicFormStatus/Processing",
    Complete = "murn:aqms2:lookup/ElectronicFormStatus/Complete",
    RepudiationPending = "murn:aqms2:lookup/ElectronicFormStatus/RepudiationPending",
  }

  export enum ElectronicFormType {
    New = "murn:aqms2:lookup/ElectronicFormType/New",
    Revision = "murn:aqms2:lookup/ElectronicFormType/Revision",
    Renewal = "murn:aqms2:lookup/ElectronicFormType/Renewal",
  }

  export enum EnforcementActionType {
    Non = "murn:aqms2:lookup/EnforcementActionType/Non",
  }

  export enum EnginePoweredEquipment {
    Other = "murn:aqms2:lookup/EnginePoweredEquipment/Other",
  }

  export enum EmissionPrevention {
    NegativeAirPressure = "murn:aqms2:lookup/EmissionPrevention/NegativeAirPressure",
  }

  export enum EmissionSource {
    Other = "murn:aqms2:lookup/EmissionSource/Other",
  }

  export enum EngineEmissionUnit {
    Other = "murn:aqms2:lookup/EngineEmissionUnit/Other",
  }

  export enum EmissionControlType {
    RefrigeratorSystem = "murn:aqms2:lookup/EmissionControlType/RefrigeratorSystem",
    Other = "murn:aqms2:lookup/EmissionControlType/Other",
  }

  export enum ExemptionApplicationType {
    New = "murn:aqms2:lookup/ExemptionApplicationType/New",
    Renewal = "murn:aqms2:lookup/ExemptionApplicationType/Renewal",
  }

  export enum FuelType {
    Biodiesel = "murn:aqms2:lookup/FuelType/Biodiesel",
    Distillate2 = "murn:aqms2:lookup/FuelType/Distillate2",
    Distillate = "murn:aqms2:lookup/FuelType/Distillate",
    LpgPropane = "murn:aqms2:lookup/FuelType/LpgPropane",
    NaturalLNG = "murn:aqms2:lookup/FuelType/NaturalLNG",
    UsedRf04 = "murn:aqms2:lookup/FuelType/UsedRf04",
    Other = "murn:aqms2:lookup/FuelType/Other",
  }

  export enum GdfRecoveryType {
    Assist = "murn:aqms2:lookup/GdfRecoveryType/Assist",
    Balance = "murn:aqms2:lookup/GdfRecoveryType/Balance",
    Healy = "murn:aqms2:lookup/GdfRecoveryType/Healy",
    Other = "murn:aqms2:lookup/GdfRecoveryType/Other",
    None = "murn:aqms2:lookup/GdfRecoveryType/None",
  }

  export enum GdfTestingReason {
    New = "murn:aqms2:lookup/GdfTestingReason/New",
    Periodic = "murn:aqms2:lookup/GdfTestingReason/Periodic",
    Retest = "murn:aqms2:lookup/GdfTestingReason/Retest",
    Other = "murn:aqms2:lookup/GdfTestingReason/Other",
  }

  export enum GdfVaporRecoverySystem {
    VaporRecovery = "murn:aqms2:lookup/GdfVaporRecoverySystem/VaporRecovery",
    VaporAssistSystem = "murn:aqms2:lookup/GdfVaporRecoverySystem/VaporAssistSystem",
    VaporBalanceSystem = "murn:aqms2:lookup/GdfVaporRecoverySystem/VaporBalanceSystem",
    HealyVaporAssistSystem = "murn:aqms2:lookup/GdfVaporRecoverySystem/HealyVaporAssistSystem",
  }

  export enum InspectionStatus {
    Pending = "murn:aqms2:lookup/InspectionStatus/Pending",
    Completed = "murn:aqms2:lookup/InspectionStatus/Completed",
    Rejected = "murn:aqms2:lookup/InspectionStatus/Rejected",
    Approved = "murn:aqms2:lookup/InspectionStatus/Approved",
    Processed = "murn:aqms2:lookup/InspectionStatus/Processed",
  }

  export enum InspectionType {
    FollowUp = "murn:aqms2:lookup/InspectionType/ComplaintInvestigationFollowup",
    Initial = "murn:aqms2:lookup/InspectionType/ComplaintInvestigationInitial",
    ReInspection = "murn:aqms2:lookup/InspectionType/ReInspection",
  }

  export enum IntakeMethod {
    Online = "murn:aqms2:lookup/IntakeMethod/Online",
  }

  export enum MachineType {
    Dry = "murn:aqms2:lookup/MachineType/Dry",
    Transfer = "murn:aqms2:lookup/MachineType/Transfer",
  }

  export enum MeasuringDevice {
    MagnehelicGauge = "murn:aqms2:lookup/MeasuringDevice/MagnahelicGauge",
    Monometer = "murn:aqms2:lookup/MeasuringDevice/Monometer",
    NotApplicable = "murn:aqms2:lookup/MeasuringDevice/NotApplicable",
    Other = "murn:aqms2:lookup/MeasuringDevice/Other",
  }

  export enum Pollutant {
    CO = "murn:aqms2:lookup/Pollutant/CO",
    CO2 = "murn:aqms2:lookup/Pollutant/CO2",
    H2S = "murn:aqms2:lookup/Pollutant/H2S",
    HAPS = "murn:aqms2:lookup/Pollutant/HAPS",
    NOX = "murn:aqms2:lookup/Pollutant/NOX",
    PB = "murn:aqms2:lookup/Pollutant/PB",
    PM = "murn:aqms2:lookup/Pollutant/PM",
    PM10 = "murn:aqms2:lookup/Pollutant/PM10",
    PM25 = "murn:aqms2:lookup/Pollutant/PM25",
    SO2 = "murn:aqms2:lookup/Pollutant/SO2",
    VOC = "murn:aqms2:lookup/Pollutant/VOC",
    Other = "murn:aqms2:lookup/Pollutant/Other",
  }

  export enum PrintMethod {
    Flexographic = "murn:aqms2:lookup/PrintMethod/Flexographic",
    Gravure = "murn:aqms2:lookup/PrintMethod/Gravure",
    Letterpress = "murn:aqms2:lookup/PrintMethod/Letterpress",
    Lithographic = "murn:aqms2:lookup/PrintMethod/Lithographic",
    Screen = "murn:aqms2:lookup/PrintMethod/Screen",
    Other = "murn:aqms2:lookup/PrintMethod/Other",
  }

  export enum PrintType {
    Press = "murn:aqms2:lookup/PrintType/Sheet",
    Web = "murn:aqms2:lookup/PrintType/Web",
    Other = "murn:aqms2:lookup/PrintType/Other",
  }

  export enum ProgramType {
    Asbestos = "murn:aqms2:lookup/ProgramType/AsbestosProgram",
    DustControl = "murn:aqms2:lookup/ProgramType/DustControlProgram",
    StationarySource = "murn:aqms2:lookup/ProgramType/StationarySourceProgram",
    VacantLand = "murn:aqms2:lookup/ProgramType/VacantLandProgram",
    Other = "murn:aqms2:lookup/ProgramType/Other",
  }

  export enum ImpingementScrubbingTower {
    Other = "murn:aqms2:lookup/ImpingementScrubbingTower/Other",
  }

  export enum InspectionCategory {
    Inspection = "murn:aqms2:lookup/InspectionCategory/Inspection",
    Investigation = "murn:aqms2:lookup/InspectionCategory/Investigation",
  }

  export enum InspectionDcopsSign {
    No = "murn:aqms2:lookup/InspectionDcopsSign/No",
    NoSignWaiver = "murn:aqms2:lookup/InspectionDcopsSign/NoSignWaiver",
    Yes = "murn:aqms2:lookup/InspectionDcopsSign/Yes",
    YesNeedsPosting = "murn:aqms2:lookup/InspectionDcopsSign/YesNeedsPosting",
    YesNeedsUpdating = "murn:aqms2:lookup/InspectionDcopsSign/YesNeedsUpdating",
  }

  export enum InspectionFugitiveDustSource {
    Other = "murn:aqms2:lookup/InspectionFugitiveDustSource/Other",
  }
  export enum InspectionProjectSize {
    Less = "murn:aqms2:lookup/InspectionProjectSize/LessThanOrEqualToPermitted",
  }

  export enum InspectionProjectSoil {
    Stable = "murn:aqms2:lookup/InspectionProjectSoil/Stable",
    Unstable = "murn:aqms2:lookup/InspectionProjectSoil/Unstable",
    FailedBmp11Requirements = "murn:aqms2:lookup/InspectionProjectSoil/FailedBmp11Requirements",
  }

  export enum InspectionTrackoutDevice {
    NoNeeded = "murn:aqms2:lookup/InspectionTrackoutDevice/NoNeeded",
    NoNotPractical = "murn:aqms2:lookup/InspectionTrackoutDevice/NoNotPractical",
    YesEffective = "murn:aqms2:lookup/InspectionTrackoutDevice/YesEffective",
    YesNotEffective = "murn:aqms2:lookup/InspectionTrackoutDevice/YesNotEffective",
  }

  export enum InspectionTrackoutRemedy {
    Immediately = "murn:aqms2:lookup/InspectionTrackoutRemedy/Immediately",
    EndOfDay = "murn:aqms2:lookup/InspectionTrackoutRemedy/EndOfDay",
  }

  export enum LocationIdentifierType {
    LatLong = "murn:aqms2:lookup/LocationIdentifierType/LatLong",
    Parcel = "murn:aqms2:lookup/LocationIdentifierType/Parcel",
    StreetAddress = "murn:aqms2:lookup/LocationIdentifierType/StreetAddress",
  }

  export enum MixingMethod {
    Other = "murn:aqms2:lookup/MixingMethod/Other",
  }

  export enum OperatingParameter {
    Other = "murn:aqms2:lookup/OperatingParameter/Other",
  }

  export enum OperationType {
    PNR = "murn:aqms2:lookup/OperationType/Pnr",
  }

  export enum EmissionInventoryType {
    OffsetLithographicLetterpress = "murn:aqms2:lookup/EmissionInventoryType/OffsetLithographicLetterpress",
    CutbackAsphaltManufacturing = "murn:aqms2:lookup/EmissionInventoryType/CutbackAsphaltManufacturing",
  }

  export enum RelocationType {
    Dcop = "murn:aqms2:lookup/RelocationType/Dcop",
    SsEu = "murn:aqms2:lookup/RelocationType/SsEu",
    PortableSs = "murn:aqms2:lookup/RelocationType/PortableSs",
    Storage = "murn:aqms2:lookup/RelocationType/Storage",
    Other = "murn:aqms2:lookup/RelocationType/Other",
  }

  export enum RemediationEquipment {
    Other = "murn:aqms2:lookup/RemediationEquipment/Other",
  }

  export enum RemediationType {
    Other = "murn:aqms2:lookup/RemediationType/Other",
  }

  export enum ScrubberType {
    Impingement = "murn:aqms2:lookup/ScrubberType/Impingement",
    Spray = "murn:aqms2:lookup/ScrubberType/Spray",
    Venturi = "murn:aqms2:lookup/ScrubberType/Venturi",
    WetCentrifugal = "murn:aqms2:lookup/ScrubberType/WetCentrifugal",
    Other = "murn:aqms2:lookup/ScrubberType/Other",
  }

  export enum TankType {
    VerticalFixed = "murn:aqms2:lookup/TankType/VerticalFixed",
  }

  export enum TestType {
    Balance = "murn:aqms2:lookup/TestType/Balance",
    Other = "murn:aqms2:lookup/TestType/Other",
  }

  export enum WetCentrifugalScrubber {
    Other = "murn:aqms2:lookup/WetCentrifugalScrubber/Other",
  }

  export enum State {
    AK = "murn:aqms2:lookup/State/AK",
    AL = "murn:aqms2:lookup/State/AL",
    AR = "murn:aqms2:lookup/State/AR",
    AS = "murn:aqms2:lookup/State/AS",
    AZ = "murn:aqms2:lookup/State/AZ",
    CA = "murn:aqms2:lookup/State/CA",
    CO = "murn:aqms2:lookup/State/CO",
    CT = "murn:aqms2:lookup/State/CT",
    DC = "murn:aqms2:lookup/State/DC",
    DE = "murn:aqms2:lookup/State/DE",
    FL = "murn:aqms2:lookup/State/FL",
    GA = "murn:aqms2:lookup/State/GA",
    GU = "murn:aqms2:lookup/State/GU",
    HI = "murn:aqms2:lookup/State/HI",
    IA = "murn:aqms2:lookup/State/IA",
    ID = "murn:aqms2:lookup/State/ID",
    IL = "murn:aqms2:lookup/State/IL",
    IN = "murn:aqms2:lookup/State/IN",
    KS = "murn:aqms2:lookup/State/KS",
    KY = "murn:aqms2:lookup/State/KY",
    LA = "murn:aqms2:lookup/State/LA",
    MA = "murn:aqms2:lookup/State/MA",
    MD = "murn:aqms2:lookup/State/MD",
    ME = "murn:aqms2:lookup/State/ME",
    MI = "murn:aqms2:lookup/State/MI",
    MN = "murn:aqms2:lookup/State/MN",
    MO = "murn:aqms2:lookup/State/MO",
    MP = "murn:aqms2:lookup/State/MP",
    MS = "murn:aqms2:lookup/State/MS",
    MT = "murn:aqms2:lookup/State/MT",
    NC = "murn:aqms2:lookup/State/NC",
    ND = "murn:aqms2:lookup/State/ND",
    NE = "murn:aqms2:lookup/State/NE",
    NH = "murn:aqms2:lookup/State/NH",
    NJ = "murn:aqms2:lookup/State/NJ",
    NM = "murn:aqms2:lookup/State/NM",
    NV = "murn:aqms2:lookup/State/NV",
    NY = "murn:aqms2:lookup/State/NY",
    OH = "murn:aqms2:lookup/State/OH",
    OK = "murn:aqms2:lookup/State/OK",
    OR = "murn:aqms2:lookup/State/OR",
    PA = "murn:aqms2:lookup/State/PA",
    PR = "murn:aqms2:lookup/State/PR",
    RI = "murn:aqms2:lookup/State/RI",
    SC = "murn:aqms2:lookup/State/SC",
    SD = "murn:aqms2:lookup/State/SD",
    TN = "murn:aqms2:lookup/State/TN",
    TX = "murn:aqms2:lookup/State/TX",
    UT = "murn:aqms2:lookup/State/UT",
    VT = "murn:aqms2:lookup/State/VT",
    VA = "murn:aqms2:lookup/State/VA",
    VI = "murn:aqms2:lookup/State/VI",
    WA = "murn:aqms2:lookup/State/WA",
    WI = "murn:aqms2:lookup/State/WI",
    WV = "murn:aqms2:lookup/State/WV",
    WY = "murn:aqms2:lookup/State/WY",
    AB = "murn:aqms2:lookup/State/AB",
    BC = "murn:aqms2:lookup/State/BC",
    MB = "murn:aqms2:lookup/State/MB",
    NB = "murn:aqms2:lookup/State/NB",
    NL = "murn:aqms2:lookup/State/NL",
    NS = "murn:aqms2:lookup/State/NS",
    ON = "murn:aqms2:lookup/State/ON",
    PE = "murn:aqms2:lookup/State/PE",
    QC = "murn:aqms2:lookup/State/QC",
    SK = "murn:aqms2:lookup/State/SK",
  }
}

/** LookupEnums (LE_CODES) must align with their associated Lookups. The associated Lookups must be marked as immutable.
 * These are just like LE enums above, but they use the Code values instead of the Murn values.
 */
export namespace LE_CODES {
  export enum ElectronicForm {
    // The naming is weird here because you can't have a leading zero in a TypeScript enum and you can't use "_" either.
    ef001 = "001_TitleV",
    ef002 = "002_AuthorityToConstruct",
    ef003 = "003_MinorSourcePermit",
    ef004 = "004_StationarySourcePermitTransfer",
    ef005 = "005_PortableSourcePermitMove",
    ef006 = "006_PetitionForExemption",
    ef007 = "007_DeclarationOfResponsibleOfficial",
    ef008 = "008_NonroadEngineDeclaration",
    ef009 = "009_PriorNotification",
    ef010 = "010_ControlDeviceWorksheet",
    ef011 = "011_CycloneWorksheet",
    ef012 = "012_FlareWorksheet",
    ef013 = "013_FabricFilterBaghouse",
    ef014 = "014_ScrubberWorksheet",
    ef015 = "015_AsphaltPlantWorksheet",
    ef016 = "016_BoilerWorksheet",
    ef017 = "017_CannabisWorksheet",
    ef018 = "018_CoolingTowerWorksheet",
    ef019 = "019_ConcretePlantWorksheet",
    ef020 = "020_DrillingBlasting",
    ef021 = "021_PerchloroethyleneDryCleaningWorksheet",
    ef022 = "022_PetroleumDryCleaningWorksheet",
    ef023 = "023_DryerHeaterOvenWorksheet",
    ef024 = "024_InternalCombustionEngineWorksheet",
    ef025 = "025_LandscapeRockOperationsWorksheet",
    ef026 = "026_PetroleumStorageTankWorksheet",
    ef027 = "027_PrintingWorksheet",
    ef028 = "028_PrintingOperationsWorksheet",
    ef029 = "029_RemediationWorksheet",
    ef030 = "030_StoneProcessingOperationsWorksheet",
    ef031 = "031_SurfaceCoatingWorksheet",
    ef032 = "032_SurfaceCoatingOperationsWorksheet",
    ef033 = "033_WoodworkingAncillaryWorksheet",
    ef034 = "034_AuthorityOperateGasDispensingGeneralPermit",
    ef035 = "035_AuthorityToOperatePermit",
    ef036 = "036_AirQualityRegistration",
    ef037 = "037_NotificationFormAQRs101",
    ef038 = "038_CertificateOfExemption",
    ef039 = "039_AppealOfHearingOfficersOrder",
    ef040 = "040_HearingRequest",
    ef041 = "041_NotificationOfAsbestosAbatement",
    ef042 = "042_DemolitionNotification",
    ef043 = "043_DryCleanerEmissionsReport",
    ef044 = "044_AnnualEmissionInventoryReport",
    ef045 = "045_SoilGroundwaterReport",
    ef046 = "046_StoneProcessingReport",
    ef047 = "047_SurfaceCoatingOperationReport",
    ef048 = "048_IndustrialOperationsReport",
    ef049 = "049_GasolineDispensingFacilitiesEmissionsReport",
    ef050 = "050_MetalOrPlasticPartsReport",
    ef051 = "051_IndustrialCleaningSolventReport",
    ef052 = "052_MetalSolventDegreaserReport",
    ef053 = "053_PrintingAndGraphicsReport",
    ef054 = "054_CutbackAsphaltReport",
    ef055 = "055_ExcessEmissionsNotification",
    ef056 = "056_SeventyTwoHourStationarySourceDeviationReport",
    ef057 = "057_Part70AnnualComplianceCertification",
    ef058 = "058_UniversalComplianceCertification",
    ef059 = "059_Method9VisibleEmissionsEvaluation",
    ef060 = "060_GasolineDispensingTestNotification",
    ef061 = "061_GasolineDispensingTestResults",
    ef062 = "062_PressureDecayTestResults",
    ef063 = "063_DynamicBackPressureTestResults",
    ef064 = "064_AirToLiquidRatioTestResults",
    ef065 = "065_LeakRateTestResults",
    ef066 = "066_FlowRateTestResults",
    ef067 = "067_StaticTorqueTestResults",
    ef068 = "068_VaporReturnLineTestResults",
    ef069 = "069_OpenBurning",
    ef070 = "070_DustControlOperatingPermit",
    ef071 = "071_ImplosionDustControlOperatingPermit",
    ef072 = "072_TemporaryCommercialActivity",
    ef073 = "073_DustControlOperatingPermitTransfer",
    ef074 = "074_DustControlOperatingPermitClosure",
    ef075a = "075a_DustClassRegistration",
    ef075b = "075b_DustClassRegistration",
    ef076 = "076_DustMonitorClassRegistration",
  }
}
